export * from './modal-container';
export {MODALS_IDS} from '@Components/modal-container/modal-container.types';
